import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.scss';

export interface LogoProps {
  id?: string;
  className?: string;
  imageClassName?: string;
  to?: string;
  onClick?: () => void;
  variant?: 'navbar' | 'footer' | 'estimator' | 'default';
  ariaLabel?: string;
}

export const LOGO_ASSET_SRC = '/logo-full.png?v=2';

export const Logo: React.FC<LogoProps> = ({
  id,
  className = '',
  imageClassName = '',
  to = '/',
  onClick,
  variant = 'default',
  ariaLabel = 'Arkatechs Home',
}) => {
  const content = (
    <img
      src={LOGO_ASSET_SRC}
      alt="Arkatechs"
      className={`${styles.logoImage} ${styles[variant]} ${imageClassName}`}
    />
  );

  if (to) {
    return (
      <Link
        to={to}
        id={id}
        onClick={onClick}
        className={`${styles.logoLink} ${className}`}
        aria-label={ariaLabel}
      >
        {content}
      </Link>
    );
  }

  return (
    <div id={id} className={`${styles.logoWrapper} ${className}`}>
      {content}
    </div>
  );
};

export default Logo;
